import React from "react";
import { Box, TextField } from "@mui/material";
import { Text } from "@src/lib/ui-react";

interface StaticProps {
  description: string;
  label: string;
}

interface Props {
  staticProps: StaticProps;
  value: string | number | undefined;
  onChange: (value: number) => void;
}

function HolidayInput({ staticProps, value, onChange }: Props) {
  const { description, label } = staticProps;

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const inputValue = event.target.value;
    const numericValue = Number.parseFloat(inputValue);

    if (!Number.isNaN(numericValue)) {
      onChange(numericValue);
    }
  }

  return (
    <Box sx={{ textAlign: "left", marginBottom: 2 }}>
      <Text sx={{ marginBottom: 1 }}>{description}</Text>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <TextField
          type="number"
          value={value}
          onChange={handleChange}
          inputProps={{
            step: 0.01,
            min: 1,
          }}
          sx={{ width: "80px" }}
          size="small"
        />
        <Text variant="body2">{label}</Text>
      </Box>
    </Box>
  );
}

export { HolidayInput };
